import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { observeResource, cacheResource } from 'kea-resource';
const controller = rpcController("EntregaOcurre");


export const EntregaOcurre = cacheResource({
    /**Realiza una entrega ocurre */
    RealizarEntrega: async (model: models.EntregaOcurreModel): Promise<number | null> => await controller("RealizarEntrega", {}, model),

    /**Consulta un listado de entregas */
    ConsultarEntregas: async (filtro: models.EntregaOcurreFiltro): Promise<models.EntregaOcurreDTO[]> => await controller('ConsultarEntregas', {}, filtro),

    /**Obtiene una entrega con todas sus listas */
    GetEntrega: async (idRegistro: number): Promise<models.EntregaOcurreDTOListas> => await controller('GetEntrega', { idRegistro }),

    /**Imprime los contrarecibos de una entrega ocurre */
    ImprimirAcusesInternos: async (idEntregaOcurre: number): Promise<string> => await controller('ImprimirAcusesInternos', { idEntregaOcurre }),
}, {
        ConsultarEntregas: true,
        GetEntrega: true,
    }, {
        RealizarEntrega: true
    });


// WEBPACK FOOTER //
// ./app/resources/items/entregaocurre.tsx